import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from "@react-navigation/native";
import React, { useEffect, useState } from 'react';
import { Modal, View } from 'react-native';
import AuthCodeInput from '../../components/Form/AuthCodeInput';
import HeaderDefault from '../../components/HeaderDefault';
import ModalPurchase from '../../components/ModalPurchase';
import ModalTransfer from '../../components/ModalTransfer';
import transferService from '../../services/transferService';
import { toast } from '../../utils/toast';
import styles from './styles';

/*
PROPS -> 
qtd float
token activeId/tokenId
userId boolean
*/

const ConfirmPasswordTransfer = (props) => {
    const navigation = useNavigation();
    const [password, setPassword] = useState('');
    const [modalVisible, setModalVisible] = useState(false);

    useEffect(() => {

        if (password.length === 6) {
            transferToken();
        }
    }, [password])

    const transferToken = async () => {
        console.log('transfer');
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        transferService.transfer(token, props.route.params.token, props.route.params.qtd, props.route.params.userId, password).then((response) => {
            console.log(response.data);
            if (response.status === 200) {
                console.log(response.data);
                setModalVisible(!modalVisible);
            } else {
                if (response?.data?.message) {
                    toast(response?.data?.message);
                } else {
                    toast("Ocorreu um problema ao realizar a transferência! Verifique seu saldo e sua senha");
                }
            }
        }).catch((error) => {
            console.log(error.response);
            if (error.response?.data?.message) {
                toast(error.response?.data?.message, "#DA1414");
            } else {
                toast("Ocorreu um problema ao realizar a transferência! Verifique seu saldo e sua senha", "#DA1414");
            }
        });
    }

    return (
        <>
            <HeaderDefault title={'Confirmar Transferência'} />

            <View style={styles.container}>
                <AuthCodeInput
                    cellCount={6}
                    isPassword={true}
                    value={password}
                    onValueChange={(value) => setPassword(value)}
                    label="Digite a sua senha "
                />
            </View>

            <Modal
                animationType="fade"
                transparent={false}
                visible={modalVisible}
                statusBarTranslucent={true}
                onRequestClose={() => navigation.navigate('Tabs')}
            >
                <ModalTransfer
                    handleCloseModal={() => {
                        setModalVisible(false);
                        navigation.navigate('Tabs');
                    }}
                    handleCloseWithTransaction={() => {
                        setModalVisible(false);
                        navigation.navigate({ name: 'Tabs', params: { openTransaction: true } });
                    }}
                />
            </Modal>
        </>
    );
}

export default ConfirmPasswordTransfer;